import type {GitHubMCPServerPullRequestReadToolArgs} from '../../../types/session'

const PULL_REQUEST_READ_METHOD_LABELS: Record<string, string> = {
  get: 'Get pull request',
  get_diff: 'Get diff',
  get_status: 'Get status',
  get_files: 'Get changed files',
  get_reviews: 'Get reviews',
  get_review_comments: 'Get review comments',
  get_comments: 'Get comments',
}

export function formatPullRequestReadTitle(args: GitHubMCPServerPullRequestReadToolArgs | undefined): string {
  const method = args?.method
  const owner = args?.owner
  const repo = args?.repo
  const pullNumber = args?.pullNumber

  const label =
    (method && PULL_REQUEST_READ_METHOD_LABELS[method]) ||
    (method ? `Read pull request (${method})` : 'Read pull request')

  if (owner && repo && pullNumber !== undefined && pullNumber !== null) {
    return `${label} on ${owner}/${repo}#${pullNumber}`
  }

  return label
}

// `pull_request_read` returns different content shapes per `method`:
// `get_diff` returns a unified diff string; other methods return JSON.
export function resolvePullRequestReadOutputLanguage(
  method: string | undefined,
  content: string | undefined,
  parseJson: (content: string | undefined) => {language: string; output: string | undefined},
): {language: string; output: string | undefined} {
  if (method === 'get_diff') {
    return {language: 'diff', output: content}
  }
  return parseJson(content)
}
